<template>
  <div>
    <headd :mobile_title="mobile_title"></headd>

    <div class="pay" v-if="pay_status == 's'">
      <div class="container">
        <div class="pay_icon">
          <img src="../../../static/pay/success.png" />
        </div>
        <div class="pay_text">
          <div class="success">
            已成功支付<!-- <text class="s_price">¥ 988</text> -->
          </div>
          <div class="tip">专业服务人员将尽快为您服务</div>
        </div>
        <div class="pay_button">
          <div class="success_back" @click="goorderdetail">查看订单</div>
          <div class="success_back" @click="gohome">返回首页</div>
        </div>
      </div>
    </div>
    <div class="pay" v-else>
      <div class="container">
        <div class="pay_icon">
          <img src="../../../static/pay/fail.png" />
        </div>
        <div class="pay_text">
          <div class="fail">
            支付失败
          </div>
          <div class="tip">请重新支付</div>
        </div>
        <div class="pay_button">
          <div class="success_back" @click="goorderdetail">重新支付</div>
          <div class="success_back" @click="gohome">返回首页</div>
        </div>
      </div>
    </div>
    <foot></foot>
  </div>
</template>

<script>
import headd from "@/components/head";
import foot from "@/components/foot";
export default {
  data() {
    return {
      mobile_title: "支付结果",
      pay_status: "s",
      orderid: 0
    };
  },
  components: {
    headd,
    foot
  },
  methods: {
    goorderdetail() {
      var id = this.orderid;
      var query = this.$route.query;
      this.$router.push({
        path: "orderdetailmanage",
        query: {
          id: query.orderid
        }
      });
    },
    gohome() {
      this.$router.push({
        path: "/"
      });
    }
  },
  onLoad(options) {
    var _self = this;
    if (options.pay_status) {
      _self.pay_status = options.pay_status;
    }
    if (options.orderid) {
      _self.orderid = options.orderid;
    }
  }
};
</script>

<style lang="less">
.pay {
  margin: 0 auto 0.6rem;
  flex-direction: column;
  text-align: left;

  .pay_icon {
    width: 2.08rem;
    height: 2.08rem;
    margin: 1rem auto 0.42rem auto;

    img {
      width: 100%;
      height: 100%;
    }
  }
  .pay_text {
    flex-direction: column;
    width: 100%;
    align-items: center;
    text-align: center;
    .fail {
      color: #ff545a;
      font-size: 0.26rem;
      margin-bottom: 0.1rem;
    }
    .success {
      color: #1b1c33;
      font-size: 0.26rem;

      margin-bottom: 0.1rem;
      .s_price {
        color: #ff545a;
        margin-left: 0.1rem;
      }
    }
    .tip {
      color: #5e5e66;
      font-size: 0.24rem;
    }
  }
  .pay_button {
    margin-top: 1.3rem;
    display: flex;
    text-align: center;
    justify-content: space-evenly;

    .fail_back {
      width: 5.9rem;
      height: 0.7rem;
      border-radius: 0.4rem;
      border: 1px solid #1395ff;
      font-size: 0.24rem;
      line-height: 0.7rem;
      justify-content: center;
      align-items: center;
      text-align: center;
      color: #1395ff;
    }
    .success_back {
      width: 3.09rem;
      height: 0.68rem;
      line-height: 0.7rem;
      border-radius: 0.4rem;
      border: 1px solid #1395ff;
      font-size: 0.24rem;
      justify-content: center;
      align-items: center;
      text-align: center;
      color: #1395ff;
      margin: 0 0.12rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/pay/pay.vue